import React from "react";
import Slider from "react-slick";

/* ---------------- LOGO DATA ---------------- */
const partnerLogos = {
  top: [
    "/assets/images/home-partnes-img1.webp",
    "/assets/images/home-partnes-img2.webp",
          "/assets/images/home-partnes-img1.webp",
    "/assets/images/supershine-slide-logo.webp",
  
    // "/assets/images/home-partnes-img8.webp",
  ],
  middle: [
    "/assets/images/forenta-icon.webp",
    "/assets/images/home-partnes-img11.webp",
    "/assets/images/laco-logo.webp",
    "/assets/images/home-partnes-img8.webp",
  ],
  bottom: [
    "/assets/images/ingerroll-icon.webp",
    "/assets/images/rema-logo.webp",
    "/assets/images/home-partnes-img13.webp",
        "/assets/images/home-partnes-img9.webp",
            "/assets/images/home-partnes-img12.webp",


  ],
};

/* ---------------- SLIDER SETTINGS ---------------- */
const commonSettings = {
  dots: false,
  slidesToShow: 4,
  infinite: true,
  autoplay: true,
  slidesToScroll: 1,
  infinite: true,
  pauseOnHover: false,
  arrows: false,
  cssEase: "linear",
  autoplaySpeed: 0,
  speed: 5000,
  responsive: [
    {
      breakpoint: 992,
      settings: { slidesToShow: 3 },
    },
    {
      breakpoint: 601,
      settings: { slidesToShow: 2 },
    },
  ],
};

export default function HomePartners() {
  return (
    <section className="logo-area">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-8">
            <div className="industries-text center-heading">
              <h3 className="heading heading-center">
                Brands and partners Who <br />Power Our Excellence
              </h3>
            </div>
          </div>
        </div>

        <div className="row justify-content-center desktop-logos">
          <div className="col-lg-12">
            {/* TOP SLIDER */}
            <Slider {...commonSettings} className="logo-slider-left slick-carousell">
              {partnerLogos.top.map((logo, index) => (
                <div className="logo-slider-box" key={index}>
                  <div className="logo-slider-img">
                    <img src={logo} alt="Partner Logo" loading="lazy" />
                  </div>
                </div>
              ))}
            </Slider>

            {/* MIDDLE SLIDER (RTL) */}
            <Slider  {...commonSettings}  rtl  className="logo-slider-center slick-carousell"  >
              {partnerLogos.middle.map((logo, i) => (
                <div className="logo-slider-box" key={i}>
                  <div className="logo-slider-img">
                    <img src={logo} alt="Partner Logo" loading="lazy" />
                  </div>
                </div>
              ))}
            </Slider>

            {/* BOTTOM SLIDER */}
            <Slider {...commonSettings} className="logo-slider-bottom slick-carousell">
              {partnerLogos.bottom.map((logo, keys) => (
                <div className="logo-slider-box" key={keys}>
                  <div className="logo-slider-img">
                    <img src={logo} alt="Partner Logo" loading="lazy" />
                  </div>
                </div>
              ))}
            </Slider>

          </div>
        </div>
      </div>
    </section>
  );
}
